import moment from 'moment';
import { Row, Col, Button, Form, Modal, message } from 'antd';
import Icon from "@mdi/react";
import { mdiArrowLeft } from "@mdi/js";
import { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useLocation } from "react-router";
import environment from "../../../../../config/environment";
import NumericInput from "../../../../widget/numericInput";
import { i18n } from '../../../../../i18n/i18n';
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../../i18n/i18n.constants";
import { format } from 'util';
import { useTimer } from 'react-timer-hook';
import { any } from 'prop-types';

const OtpPage = () => {
  const location: any = useLocation()
  const history = useHistory();
  const [isTimerOut, setTimerOut] = useState(false);
  const [otp, setOtp] = useState({});
  const [run, setRun] = useState(0);
  const [valueOtp, setValueOtp] = useState("");
  const [textNumber, setTextNumber] = useState("");
  const [dataOtp, setDataOtp] = useState<any>({})
  const [dataCustomer, setDataCustomer] = useState<any>({})
  const [expiryTimestamp, setexpiryTimestamp] = useState(new Date());
  const { restart } = useTimer({ expiryTimestamp });
  const [isTimer, setTimer] = useState(new Date());

  const { t } = useTranslation(namespaces.pages.daolinv);


  function MyTimer({ expiryTimestamp }) {
    const {
      seconds,
      minutes,
      isRunning,
    } = useTimer({ expiryTimestamp, onExpire: () => setTimerOut(true) });

    return (
      <div>
        <p>{isRunning ? (<span>{minutes}{`:`}{seconds}</span>) : ('0:0')}</p>
        {/* <button onClick={() => {
          // Restarts to 5 minutes timer
          const time = new Date();
          time.setSeconds(time.getSeconds() + 20);
          //time.setSeconds(time.getSeconds() + 180);
          restart(time)
        }}>Restart</button> */}

      </div>
    );
  }

  const getCustomer = () => {
    axios.get(`${environment?.baseApi}/customer?customerId=${location?.state?.customerId}`)
      .then(res => {
        console.log('Get Customr', res.data)
        if (res.status === 200) {
          setDataCustomer(res.data);
        } else {
          Modal.error({
            title: t("popup_login_error_title"),
            content: t("popup_login_error_content"),
            icon: '',
            onOk() {
              console.log('OnOKay');
              history.push('/contents/daolInv/consentRMF/loginMember')
            },
          });
        }

      }).catch((error) => {
        Modal.error({
          title: t("popup_error500_title"),
          content: t("popup_error500_content"),
          icon: '',
          onOk() {
            console.log('OnOKay');
            history.push('/contents/daolInv/consentRMF/loginMember')
          },
        });
        console.error('catch error', error);
      });
  };


  const genOTP = async () => {
    const urlMobile = `${environment?.baseApi}/sent`
    axios.post(urlMobile, {
      senderName: "DAOL-INV",
      phoneNumber: location?.state?.phone,
      lang: i18n.language === "th" ? "TH" : "EN"
    })
      .then(res => {
        console.log('genOTP', res.status)
        if (res.status === 200) {
          setDataOtp(res.data);
        } else {
          Modal.error({
            title: t("popup_login_error_title"),
            content: t("popup_login_error_content"),
            icon: '',
            onOk() {
              console.log('OnOKay');
              history.push('/contents/daolInv/consentRMF/loginMember')
            },
          });
        }

      }).catch((error) => {
        Modal.error({
          title: t("popup_error500_title"),
          content: t("popup_error500_content"),
          icon: '',
          onOk() {
            console.log('OnOKay');
            history.push('/contents/daolInv/consentRMF/loginMember')
          },
        });
        console.error('catch error', error);
      });
  };

  const resendOtp = async () => {
    await genOTP();
    const time = new Date();
    time.setSeconds(time.getSeconds() + 180);
    setTimer(time);
    restart(time);
    setTimerOut(false);

  };
  const calculateTimeLeft = async () => {
    let text = location?.state?.phone;
    let result = text.substring(0, 6);
    setTextNumber(result);
    await genOTP();
  };

  const onSubmitOTP = async () => {
    // //? Test
    // history.push({
    //   pathname: "/contents/daolInv/consentRMF/consentSelect",
    //   state: {
    //     customerName: dataCustomer?.customerName,
    //     customerId: location?.state?.customerId,
    //     taxId: dataCustomer?.taxId,
    //     taxYear: dataCustomer?.taxYear,
    //     phoneNumber : location?.state?.phone
    //   },
    // });
    // return 0;

    const urlValidate = `${environment?.baseApi}/validate`
    axios.post(urlValidate, {
      senderName:  "DAOL-INV",
      phoneNumber: dataOtp?.data?.phoneNumber,
      refCode: dataOtp?.data?.refCode,
      otp: valueOtp,
    })
      .then(res => {
        console.log('res.status onSubmitOTP', res.status);
        // if (res.data.type === "Success") {
        //   console.log('res', res.data);
        //   history.push({
        //     pathname: "/contents/daolInv/consentRMF/consent",
        //     state: {
        //       customerName: dataCustomer?.customerName,
        //       customerId: location?.state?.customerId,
        //       taxId: dataCustomer?.taxId,
        //       taxYear: dataCustomer?.taxYear,
        //     },
        //   });
        if (res.data.message === "Success") {
          console.log('res', res.data);
          history.push({
            pathname: "/contents/daolInv/consentRMF/consentSelect",
            state: {
              customerName: dataCustomer?.customerName,
              customerId: location?.state?.customerId,
              taxId: dataCustomer?.taxId,
              taxYear: dataCustomer?.taxYear,
              phoneNumber : location?.state?.phone
            },
          });
        } else {
          Modal.error({
            title: t("otp_error_title"),
            content: t("otp_error_wrong"),
            icon: '',
            onOk() {
              console.log('OnOKay');
            },
          });

        }
      }).catch((error) => {
        console.error(error);
      });
  };


  useEffect(() => {
    calculateTimeLeft();
    getCustomer();
    const time = new Date();
    time.setSeconds(time.getSeconds() + 180);
    // time.setSeconds(time.getSeconds() + 20);
    setTimer(time);
    setTimerOut(false);
    if (run === 0) {
      // calculateTimeLeft();
      // setRun(1);
      // let _lt = calculateTimeLeft();
      // console.log("_lt", _lt)
      // console.log("dataOtp?.data.createDate", dataOtp?.data.createDate)
      // startCountdown(dataOtp?.data.createDate); 
      // const d = new Date(dataText.expireDate);
      // let text = d.toLocaleTimeString();
      // setText(text);
    }
  }, [location]);



  return (
    <>
      <div className="home-page">
        {console.log("value OTP", valueOtp.length)}
        {console.log('otp', otp)}
        {console.log('StateStateState', location?.state?.phone)}
        {console.log('timetimetime', isTimerOut)}
        {console.log('expiryTimestamp', expiryTimestamp)}
        {/* {console.log('dataOtpdataOtpdataOtp', dataOtp)}
        {console.log('dataOtpdataOtpdataOtp', dataOtp?.data?.refCode)}
        {console.log('dataOtp?.data.createDate',new Date(dataOtp?.data?.createDate))}
        {console.log('dataOtp?.data.expireDate',new Date(dataOtp?.data?.expireDate))} */}
        {/* {console.log('new Date()', new Date())} */}

        <div className="container">
          <Row className="container-main row">
            <div className="content-left col-sm-5">
              <a onClick={() => history.push("/contents/daolInv/consentRMF/loginMember")}>
                <Icon path={mdiArrowLeft} size="30" color="#FFFFFF" />
              </a>
              <div className="info-left">
                <p className="text-center text-header">
                  {t("otp_title")}
                </p>
                <p className="content-sub">
                  {t("otp_text_descrip")}
                </p>
              </div>
            </div>
            <div className="content-right col-sm-7">
              <p className="text-center text-header">{t("otp_descrip_header")}</p>
              <Form
                name="normal_otp"
                className="login-form"
                initialValues={{ remember: true }}
                onFinish={onSubmitOTP}
              >
                <p>{textNumber}xxxx {t("otp_descrip_p1")}</p>
                <Form.Item
                  name="otp"
                  className="from-otp"
                  rules={[{ required: true, message: t("otp_error_form") }]}
                >
                  <NumericInput value={valueOtp} onChange={setValueOtp} />
                </Form.Item>
                <Row className="refer-otp">
                  <Col span={12}>{t("otp_refCode")} {dataOtp?.data?.refCode}</Col>
                  <Col span={12} className="text-right">
                    {/* {loading === true ? <Countdown renderer={renderer} date={Date.now() + 19520} /> : <span>00:00</span>} */}

                    <MyTimer expiryTimestamp={isTimer} />

                    {/* {isTimerRunning ? (
                      <Countdown
                        timerData={timer}
                        // stopCountdown={stopCountdown}
                      />
                    ) : (
                      <span>0:00</span>
                    )} */}
                  </Col>
                </Row>


                <Form.Item className="container-button">
                  <p>
                    {isTimerOut === true ? (
                      <Button type="primary" onClick={async e => { await resendOtp() }}>
                        {t("btn_otp")}
                      </Button>
                    ) : ""}

                  </p>
                  {valueOtp.length === 6 ? (
                    <Button type="primary" htmlType="submit">
                      {t("btn_next")}
                    </Button>
                  ) : (
                    <Button type="primary" disabled>
                      {t("btn_next")}
                    </Button>
                  )}
                </Form.Item>
              </Form>
            </div>
          </Row>
        </div>
      </div>
    </>
  );
};
export default OtpPage;
